import { Identifiable } from "@planzone/dto";

type Cost = {
  startDate: string;
  cost: number;
};

type CostProfileCostsHistory = Identifiable<Cost>[];

const costProfileCostsHistory: CostProfileCostsHistory = [];

export type { CostProfileCostsHistory };

export { costProfileCostsHistory };
